function abortable() {
  let aborted = false;
  return {
    abort() {
      if (typeof window === 'undefined') {
        throw new Error('Called abort on the server');
      }
      aborted = true;
    },
    isAborted() {
      return aborted;
    },
  };
}

export default abortable;



// WEBPACK FOOTER //
// ./utils/abortable.jsx